import { IDataEndPoint, IEntityEndPoints, IFieldOptions, IFormOptions, IGridOptions, IColumnOptions, IEntityOptions } from '@framework/interfaces/IEntity';
import * as app from '@framework/app';
import * as models from '@common/domain/models/JobCardDTO';
import { IApiServiceCommand } from '@services/api/api.service';
export class JobCardEndPoints implements IEntityEndPoints {
	list?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/jobCard"}, method: "GET" };
	get?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/jobCard/" + serviceCommand.context.entityId}, method: "GET" };
	update?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/jobCard/update/" + serviceCommand.context.entityId}, method: "POST" };
	search?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/jobCard/lazy/"}, method: "POST" };
	pagingTotalCount?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/jobCard/lazyCount/"}, method: "POST" };
	insert?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/jobCard/create"}, method: "POST" };
	delete?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/jobCard/delete/"+ serviceCommand.context.entityId}, method: "POST" };
}

export class JobCardFormFields extends Array<IFieldOptions> {
	public id: IFieldOptions = { field: "id" };
	public workOrderId: IFieldOptions = { field: "workOrderId" };
	public jobCardNo: IFieldOptions = { field: "jobCardNo" };
	public dateIssued: IFieldOptions = { field: "dateIssued" };
	public operationId: IFieldOptions = { field: "operationId" };
	public priorityId: IFieldOptions = { field: "priorityId" };
	public dateScopedOut: IFieldOptions = { field: "dateScopedOut" };
	public dateScopedIn: IFieldOptions = { field: "dateScopedIn" };
	public dateScopeEstimator: IFieldOptions = { field: "dateScopeEstimator" };
	public dateQuoteSubmitted: IFieldOptions = { field: "dateQuoteSubmitted" };
	public plannedAmountExVat: IFieldOptions = { field: "plannedAmountExVat" };
	public dateOriginalPOIssued: IFieldOptions = { field: "dateOriginalPOIssued" };
	public originalPurchaseOrderNo: IFieldOptions = { field: "originalPurchaseOrderNo" };
	public plannedStartDate: IFieldOptions = { field: "plannedStartDate" };
	public actualStartDate: IFieldOptions = { field: "actualStartDate" };
	public dateHandedOver: IFieldOptions = { field: "dateHandedOver" };
	public handoverCertNo: IFieldOptions = { field: "handoverCertNo" };
	public datestamp: IFieldOptions = { field: "datestamp" };
	public changedBy: IFieldOptions = { field: "changedBy" };
	public status: IFieldOptions = { field: "status" };
	public contactPersonId: IFieldOptions = { field: "contactPersonId" };
	public contactNo: IFieldOptions = { field: "contactNo" };
	public workflowStatusId: IFieldOptions = { field: "workflowStatusId" };
	public plannedCompletionDate: IFieldOptions = { field: "plannedCompletionDate" };
	public actualCompletionDate: IFieldOptions = { field: "actualCompletionDate" };
	public dateCancelled: IFieldOptions = { field: "dateCancelled" };
	public dateDocsRcvd: IFieldOptions = { field: "dateDocsRcvd" };
	public dateDocsToCommercial: IFieldOptions = { field: "dateDocsToCommercial" };
	public remarks: IFieldOptions = { field: "remarks" };
	public amount: IFieldOptions = { field: "amount" };
	public prefix: IFieldOptions = { field: "prefix" };
	public wipStatus: IFieldOptions = { field: "wipStatus" };
	public shutDownCard: IFieldOptions = { field: "shutDownCard" };
	public buildAmount: IFieldOptions = { field: "buildAmount" };
	public breakAmount: IFieldOptions = { field: "breakAmount" };
	public hireAmount: IFieldOptions = { field: "hireAmount" };
	public miscellaneousAmount: IFieldOptions = { field: "miscellaneousAmount" };
	public tempJobCardNo: IFieldOptions = { field: "tempJobCardNo" };
	public quoteNumber: IFieldOptions = { field: "quoteNumber" };
	constructor() {
		super();
		this.push(this.id);
		this.push(this.workOrderId);
		this.push(this.jobCardNo);
		this.push(this.dateIssued);
		this.push(this.operationId);
		this.push(this.priorityId);
		this.push(this.dateScopedOut);
		this.push(this.dateScopedIn);
		this.push(this.dateScopeEstimator);
		this.push(this.dateQuoteSubmitted);
		this.push(this.plannedAmountExVat);
		this.push(this.dateOriginalPOIssued);
		this.push(this.originalPurchaseOrderNo);
		this.push(this.plannedStartDate);
		this.push(this.actualStartDate);
		this.push(this.dateHandedOver);
		this.push(this.handoverCertNo);
		this.push(this.datestamp);
		this.push(this.changedBy);
		this.push(this.status);
		this.push(this.contactPersonId);
		this.push(this.contactNo);
		this.push(this.workflowStatusId);
		this.push(this.plannedCompletionDate);
		this.push(this.actualCompletionDate);
		this.push(this.dateCancelled);
		this.push(this.dateDocsRcvd);
		this.push(this.dateDocsToCommercial);
		this.push(this.remarks);
		this.push(this.amount);
		this.push(this.prefix);
		this.push(this.wipStatus);
		this.push(this.shutDownCard);
		this.push(this.buildAmount);
		this.push(this.breakAmount);
		this.push(this.hireAmount);
		this.push(this.miscellaneousAmount);
		this.push(this.tempJobCardNo);
		this.push(this.quoteNumber);
	}
}

export class JobCardForm implements IFormOptions {
	protected jobCardFormName: string = "jobCardForm";
	protected jobCardFormModel: models.JobCardDTO = new models.JobCardDTO();
	protected jobCardFormEndPoints: JobCardEndPoints = new JobCardEndPoints();
	protected jobCardFormFields: JobCardFormFields = new JobCardFormFields();
	public get name(): string { return this.jobCardFormName };
	public get model(): models.JobCardDTO { return this.jobCardFormModel };
	public get endPoints(): IEntityEndPoints { return this.jobCardFormEndPoints };
       public set endPoints(jobCardEndPoints: IEntityEndPoints) {
		this.jobCardFormEndPoints = jobCardEndPoints;
	};
	public get dataEndPoint(): IDataEndPoint { return this.endPoints.get };
	public get fields(): JobCardFormFields { return this.jobCardFormFields };
}

export class JobCardListColumns extends Array<IColumnOptions> {
	public id: IColumnOptions = { field: "id" };
	public workOrderId: IColumnOptions = { field: "workOrderId" };
	public jobCardNo: IColumnOptions = { field: "jobCardNo" };
	public dateIssued: IColumnOptions = { field: "dateIssued", template: function (fldValue) { return (new Date(fldValue)["shortDate"]()).toString(); } };
	public operationId: IColumnOptions = { field: "operationId" };
	public priorityId: IColumnOptions = { field: "priorityId" };
	public dateScopedOut: IColumnOptions = { field: "dateScopedOut", template: function (fldValue) { return (new Date(fldValue)["shortDate"]()).toString(); } };
	public dateScopedIn: IColumnOptions = { field: "dateScopedIn", template: function (fldValue) { return (new Date(fldValue)["shortDate"]()).toString(); } };
	public dateScopeEstimator: IColumnOptions = { field: "dateScopeEstimator", template: function (fldValue) { return (new Date(fldValue)["shortDate"]()).toString(); } };
	public dateQuoteSubmitted: IColumnOptions = { field: "dateQuoteSubmitted", template: function (fldValue) { return (new Date(fldValue)["shortDate"]()).toString(); } };
	public plannedAmountExVat: IColumnOptions = { field: "plannedAmountExVat" };
	public dateOriginalPOIssued: IColumnOptions = { field: "dateOriginalPOIssued", template: function (fldValue) { return (new Date(fldValue)["shortDate"]()).toString(); } };
	public originalPurchaseOrderNo: IColumnOptions = { field: "originalPurchaseOrderNo" };
	public plannedStartDate: IColumnOptions = { field: "plannedStartDate", template: function (fldValue) { return (new Date(fldValue)["shortDate"]()).toString(); } };
	public actualStartDate: IColumnOptions = { field: "actualStartDate", template: function (fldValue) { return (new Date(fldValue)["shortDate"]()).toString(); } };
	public dateHandedOver: IColumnOptions = { field: "dateHandedOver", template: function (fldValue) { return (new Date(fldValue)["shortDate"]()).toString(); } };
	public handoverCertNo: IColumnOptions = { field: "handoverCertNo" };
	public datestamp: IColumnOptions = { field: "datestamp", template: function (fldValue) { return (new Date(fldValue)["shortDate"]()).toString(); } };
	public changedBy: IColumnOptions = { field: "changedBy" };
	public status: IColumnOptions = { field: "status" };
	public contactPersonId: IColumnOptions = { field: "contactPersonId" };
	public contactNo: IColumnOptions = { field: "contactNo" };
	public workflowStatusId: IColumnOptions = { field: "workflowStatusId" };
	public plannedCompletionDate: IColumnOptions = { field: "plannedCompletionDate", template: function (fldValue) { return (new Date(fldValue)["shortDate"]()).toString(); } };
	public actualCompletionDate: IColumnOptions = { field: "actualCompletionDate", template: function (fldValue) { return (new Date(fldValue)["shortDate"]()).toString(); } };
	public dateCancelled: IColumnOptions = { field: "dateCancelled", template: function (fldValue) { return (new Date(fldValue)["shortDate"]()).toString(); } };
	public dateDocsRcvd: IColumnOptions = { field: "dateDocsRcvd", template: function (fldValue) { return (new Date(fldValue)["shortDate"]()).toString(); } };
	public dateDocsToCommercial: IColumnOptions = { field: "dateDocsToCommercial", template: function (fldValue) { return (new Date(fldValue)["shortDate"]()).toString(); } };
	public remarks: IColumnOptions = { field: "remarks" };
	public amount: IColumnOptions = { field: "amount" };
	public prefix: IColumnOptions = { field: "prefix" };
	public wipStatus: IColumnOptions = { field: "wipStatus" };
	public shutDownCard: IColumnOptions = { field: "shutDownCard" };
	public buildAmount: IColumnOptions = { field: "buildAmount" };
	public breakAmount: IColumnOptions = { field: "breakAmount" };
	public hireAmount: IColumnOptions = { field: "hireAmount" };
	public miscellaneousAmount: IColumnOptions = { field: "miscellaneousAmount" };
	public tempJobCardNo: IColumnOptions = { field: "tempJobCardNo" };
	public quoteNumber: IColumnOptions = { field: "quoteNumber" };
	constructor() {
		super();
		this.push(this.id);
		this.push(this.workOrderId);
		this.push(this.jobCardNo);
		this.push(this.dateIssued);
		this.push(this.operationId);
		this.push(this.priorityId);
		this.push(this.dateScopedOut);
		this.push(this.dateScopedIn);
		this.push(this.dateScopeEstimator);
		this.push(this.dateQuoteSubmitted);
		this.push(this.plannedAmountExVat);
		this.push(this.dateOriginalPOIssued);
		this.push(this.originalPurchaseOrderNo);
		this.push(this.plannedStartDate);
		this.push(this.actualStartDate);
		this.push(this.dateHandedOver);
		this.push(this.handoverCertNo);
		this.push(this.datestamp);
		this.push(this.changedBy);
		this.push(this.status);
		this.push(this.contactPersonId);
		this.push(this.contactNo);
		this.push(this.workflowStatusId);
		this.push(this.plannedCompletionDate);
		this.push(this.actualCompletionDate);
		this.push(this.dateCancelled);
		this.push(this.dateDocsRcvd);
		this.push(this.dateDocsToCommercial);
		this.push(this.remarks);
		this.push(this.amount);
		this.push(this.prefix);
		this.push(this.wipStatus);
		this.push(this.shutDownCard);
		this.push(this.buildAmount);
		this.push(this.breakAmount);
		this.push(this.hireAmount);
		this.push(this.miscellaneousAmount);
		this.push(this.tempJobCardNo);
		this.push(this.quoteNumber);
	}
}

export class JobCardList implements IGridOptions {
	protected jobCardListName: string = "jobCardList";
	protected jobCardListModel: models.JobCardDTO = new models.JobCardDTO();
	protected jobCardListEndPoints: JobCardEndPoints = new JobCardEndPoints();
	protected jobCardListColumns: JobCardListColumns = new JobCardListColumns();
	public jobCardForm: JobCardForm = new JobCardForm();
	public get name(): string { return this.jobCardListName };
	public get model(): models.JobCardDTO { return this.jobCardListModel };
	public get endPoints(): IEntityEndPoints { return this.jobCardListEndPoints };
	public set endPoints(jobCardEndPoints: IEntityEndPoints) {
		this.jobCardListEndPoints = jobCardEndPoints;
		this.jobCardForm.endPoints = this.endPoints;
	};
	public get dataEndPoint(): IDataEndPoint { return this.endPoints.list };
	public get columns(): JobCardListColumns { return this.jobCardListColumns };
}

export class JobCardEntity implements IEntityOptions {
	protected jobCardEntityName: string = "jobCardEntity";
	protected jobCardEntityModel: models.JobCardDTO = new models.JobCardDTO();
	protected jobCardEntityEndPoints: JobCardEndPoints = new JobCardEndPoints();
	protected jobCardEntityList: JobCardList = new JobCardList();
	public get name(): string { return this.jobCardEntityName };
	public get model(): models.JobCardDTO { return this.jobCardEntityModel };
	public get endPoints(): IEntityEndPoints { return this.jobCardEntityEndPoints };
	public set endPoints(jobCardEndPoints: IEntityEndPoints) {
		this.jobCardEntityEndPoints = jobCardEndPoints;
		this.grid.endPoints = this.endPoints;
	};
	public get grid(): JobCardList { return this.jobCardEntityList };
	public get form(): JobCardForm { return this.grid.jobCardForm };
	constructor(name?: string) {
		if (name) this.jobCardEntityName = name;
		this.endPoints = this.jobCardEntityEndPoints;
	}
};
//export class JobCardGeneratedForm extends MfGeneratedFormComponent {
 // protected detailPageComponentForm: JobCardForm = new JobCardForm();
//};

//export class JobCardListPageComponent extends ListPageComponent {
  //protected listPageComponentList: JobCardList = new  JobCardList();
  //protected showFilterColOnTable: boolean = true;
//};

//export class JobCardBlade extends MfBladeComponent {
  //protected detailComponents: Array<IDetailComponent> = [ { index: 0, displayName: "Properties", component: JobCardGeneratedForm}];
//};

//export class JobCardListBlade extends MfBladeComponent {
 // protected detailComponents: Array<IDetailComponent> = [ { index: 0, displayName: "Properties", component: JobCardListPageComponent, isMenuHidden: true }];
//};

